export default [
  {path: '/PrivacyZml', name: 'privacyPolicy', component: () => import('@/view/privacyPolicy/privacyPolicy'),},
  {path: '/yundongexplain', name: 'yundongexplain', component: () => import('@/view/zmlApp/TZCexplain/TZCexplain'),},
  {path: '/userAgreement', name: 'userAgreement', component: () => import('@/view/zmlApp/userAgreement/index'),},
];



// WEBPACK FOOTER //
// src/router/zmlApp.js